import React from 'react';
import './Footer.css';

import { Logo} from '../../components';
import { contactContent, services } from '../../constants'; // Importing contact information and services data

// Importing necessary icons from react-icons
import { FaFacebookF, FaInstagram, FaLeaf } from 'react-icons/fa';

// Importing Link for navigation
import { Link } from 'react-router-dom'; 
 
const Footer = () => {   
  
  return (
    <footer className='footer'>
      
      <div className='box-container'>

        {/* About Section */}
        <div className='footer-item'>

          <Logo /> {/* Display the Logo component */}
                  <p>Fundacja Dwór Imielno  - Centrum Kultury Obszarów Wiejskich, Edukacji Ekologicznej i Zachowania Różnorodności Biologicznej</p> {/* Description for the about section */}

          {/* Filtering out the contact with id 4 and displaying the remaining contact info */}
          <div className='info connect'>
            {contactContent
              .filter(contact => contact.id !== 4) // Exclude the contact with id: 4
              .map((contact) => {
                return (
                  <p key={contact.id}>
                    <span className='icon'>{contact.icon}</span>
                    {contact.content[0]} {/* Only show the first value from content */}
                  </p>
                );
              })}
          </div>

          {/* Social media icons with links */}
          <div className='social'>
            <a href="https://www.facebook.com/profile.php?id=61584478547291&locale=pl_PL"><FaFacebookF className='icon' /></a>    
            <a href="https://www.instagram.com/dwor.imielno?igsh=cmkxM2M0bWR0cTZj"><FaInstagram className='icon' /></a>
            {/*            <a href="/#"><FaXTwitter className='icon' /></a>
            <a href="/#"><FaLinkedin className='icon' /></a>*/}
          </div>

        </div>

        {/* Services Links Section */}
        <div className='footer-item'> 

          <h2>Oferta</h2>

          <div className='info links'> 
            {/* Mapping through the services and creating links to each service page */}
            {services.map(service => {
              /* Link to the individual service page */
              return <p key={service.id}><FaLeaf className='icon' /> 
                <Link
                  to={`/Uslugi/${service.id}`}
                  state={service} // Passing service data in state
                >
                  {service.title}  {/* Display Service Title */}
                </Link>
              </p>
            })}
          </div>
        </div>

        {/* Useful Links Section */}
        <div className='footer-item'> 

          <h2>Szybkie linki</h2>

          {/* Links for easy navigation to various pages */}
          <div className='info links'> 
            <p><FaLeaf className='icon' /><Link to='/O-nas'>O nas</Link></p>
            <p><FaLeaf className='icon' /><Link to='/Uslugi'>Usługi</Link></p>
            <p><FaLeaf className='icon' /><Link to='/Skontaktuj-sie'>Kontakt</Link></p>
          </div>

        </div>

      </div>
 
      <div className='content'>
        {/* Footer content with copyright information */}
        <p>designed by <span>Edyta Szymańska</span> | all rights reserved</p>
      </div>
      
    </footer>
  )
}

export default Footer;